export const LAYOUT = {
  SPACE: 0,
};

export const HEADER = {
  TOP: 64,
  T_MOBILE: 64,
  T_TABLET: 64,
  BOTTOM: 62,
  B_MOBILE: 'auto',
  B_TABLET: 'auto',
  H_MOBILE: 180,
  H_TABLET: 180,
  H_DESKTOP: 180,
  H_DESKTOP_OFFSET: 64 - 16,
  PADDING: 16,
  BORDER_RADIUS: 0,
};

export const NAV = {
  W_VERTICAL: 294,
  W_MINI: 48,
};

export const SIDENAV = {
  W: 48,
  W_EXPANDED: 200,
};
